import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../components/Logo";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-obsidian noise">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <form onSubmit={submit} className="rounded-lg border border-white/10 bg-obsidian-800 p-8" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-neon mb-6"><Lock size={18} /><span className="font-mono text-xs uppercase tracking-widest">Staff Access</span></div>
          <h1 className="font-heading font-black text-3xl mb-6">Admin Login</h1>
          {error && <p className="mb-4 rounded-sm bg-destructive/10 border border-destructive/30 px-4 py-3 text-sm text-red-400" data-testid="login-error">{error}</p>}
          <label className="font-mono text-[11px] uppercase tracking-widest text-zinc-500">Email</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="login-email"
            className="mt-2 mb-4 w-full bg-obsidian-700 border border-white/10 rounded-sm p-3.5 text-sm outline-none focus:border-neon" />
          <label className="font-mono text-[11px] uppercase tracking-widest text-zinc-500">Password</label>
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required data-testid="login-password"
            className="mt-2 mb-6 w-full bg-obsidian-700 border border-white/10 rounded-sm p-3.5 text-sm outline-none focus:border-neon" />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full rounded-sm bg-neon px-6 py-3.5 font-bold text-obsidian shadow-neon hover:bg-neon-hover transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
